import template from './form.html';
import { FormActions } from 'core/services/form';
import { rest } from 'core/api';
import cuotasI18N from 'i18n/cuotas/es.json';
import commonI18N from 'i18n/common/es.json';
import { formatErrorMessage } from 'core/util';

export let CobrarCuotaForm = {
  templateUrl: template,
  selector: 'cobrarCuotaForm',
  bindings: {
    view: '<',
    translations: '='
  },
  controller: FormController,
  controllerAs: 'vm'
};

export const translationKeys = Object.keys(cuotasI18N).concat(Object.keys(commonI18N));


FormController.$inject = [
  '$state', '$scope', '$filter', '$ngRedux', 'ngNotify', '$stateParams', 'Filter', 'BasicFactory', '$timeout', 'localStorageService', 'CustomModal'
];

function FormController($state, $scope, $filter, $ngRedux, ngNotify, $stateParams, Filter, BasicFactory, $timeout, localStorageService, CustomModal) {

  this.handleStatus = handleStatus.bind(this);
  this.mapStateToThis = mapStateToThis.bind(this);
  this.doSubmit = doSubmit.bind(this);
  this.newDetalle = newDetalle.bind(this);
  this.deleteDetalle = deleteDetalle.bind(this);
  this.renderDescripcionFormaPago = renderDescripcionFormaPago.bind(this);
  this.renderCliente = renderCliente.bind(this);
  this.renderFormaPago = renderFormaPago.bind(this);
  this.onSelectFormaPago = onSelectFormaPago.bind(this);
  this.setTotales = setTotales.bind(this);
  this.updateTotales = updateTotales.bind(this);
  this.cancel = cancel.bind(this);
  this.onCantidadCuotasAPagarChange = onCantidadCuotasAPagarChange.bind(this);
  this.onMontoAPagarChange = onMontoAPagarChange.bind(this);
  this.verFactura = verFactura.bind(this);

  const activoFilter = Filter.path('estado.value').eq('Activo');

  let unsubscribe;
  this.$onDestroy = () => {
    this.form();
    $ngRedux.dispatch(rest.actions.timbradosVigentes.reset());
    unsubscribe();
  };

  this.$onInit = () => {
    ngNotify.dismiss();
    unsubscribe = $ngRedux.connect(this.mapStateToThis, FormActions)(this);

    let caja = localStorageService.get('caja');
    if (!caja) {
      ngNotify.set(this.translations['Debe asignar una caja al equipo'], 'warn');
      $state.go('home.cuotas.list');
      return;
    } else if (caja.sesionActual && caja.sesionActual.estado.value !== 'Abierta') {
      ngNotify.set(this.translations['Debe abrir la caja para cobrar'], 'warn');
      $state.go('home.cuotas.list');
      return;
    }

    if ($stateParams.uid) {
      this.title = this.translations['Cobro de cuotas'];
      this.formEdit('cuotas', $stateParams.uid);
    } else {
      $state.go('home.cuotas.list');
      return;
    }
    $ngRedux.dispatch(rest.actions.formasPago({ filter: JSON.stringify(activoFilter) }));
    $ngRedux.dispatch(rest.actions.marcasTarjetas({ filter: JSON.stringify(activoFilter) }));
    $ngRedux.dispatch(rest.actions.emisoresTarjetas({ filter: JSON.stringify(activoFilter) }));
    $ngRedux.dispatch(rest.actions.procesadorasTarjetas({ filter: JSON.stringify(activoFilter) }));
    
    $timeout(function() {
      $scope.$broadcast('init');
    }, 20);
  };


  this.localModel = {
    factura: {},
    totalServicios: $filter('currency')(0, 'Gs.', 0),
    totalProductos: $filter('currency')(0, 'Gs.', 0),
    total: $filter('currency')(0, 'Gs.', 0),
    detalles: [],
    nuevoDetalle: {},
    totalDetalles: 0,
    vuelto: 0,
    montoCuotas: $filter('currency')(0, 'Gs.', 0)
  };

  this.payloadCuotas = {
    montoAPagar: 0,
    cantidadCuotasAPagar: 1
  }

  this.submitted = false;

  function mapStateToThis(state) {
    this.handleStatus(state);

    this.model = state.form.model;

    if (!this.modelInit && this.model.id) {
      this.modelInit = true;
      this.localModel.factura.total = $filter('currency')(this.model.factura.total, 'Gs.', 0);
      this.localModel.saldo = $filter('currency')(this.model.saldo, 'Gs.', 0);
      this.localModel.entregaInicial = $filter('currency')(this.model.entregaInicial, 'Gs.', 0);
      if (this.model.entregaInicial > 0) {
        this.localModel.entregaInicial = this.localModel.entregaInicial + ' (Recibo Nro. ' + this.model.numeroReciboEntregaInicial + ')'
      }
      this.localModel.montoCuotas = $filter('currency')(this.model.montoCuotas, 'Gs.', 0);
      this.localModel.excedente = $filter('currency')(this.model.excedente, 'Gs.', 0);
      this.localModel.factura.cliente = this.renderCliente(this.model.factura.cliente);
      this.onCantidadCuotasAPagarChange();
    }
    
    if (state.formasPago.data.length && !this.formaPagoDefault) {
      this.formaPagoDefault = state.formasPago.data.filter(v => v.formaDesembolso.value === 'Efectivo')[0];
      this.localModel.nuevoDetalle.formaPago = this.formaPagoDefault;
    }

    this.procesadorasTarjetas = state.procesadorasTarjetas.data;

    if (this.model.formaPagoDescuento && !this.formaPagoDescuentoInit) {
      this.formaPagoDescuentoInit = true;
      this.formaPagoDefault = this.model.formaPagoDescuento;
      this.localModel.nuevoDetalle.formaPago = this.formaPagoDefault;
      if (!this.procesadorasTarjetasFiltradas) {
        this.filterProcesadora();
      }
    }

    return {
      form: state.form,
      formasPago: state.formasPago.data,
      marcasTarjetas: state.marcasTarjetas.data,
      emisoresTarjetas: state.emisoresTarjetas.data
    };
  }

  function setTotales() {
    let totalServicios = 0;
    let totalProductos = 0;

    this.model.factura.detalles.forEach(function(detalle) {
      let descuento = detalle.descuento ? detalle.descuento : 0;
      if (detalle.producto) {
        totalProductos += detalle.precio - descuento;
      } else {
        totalServicios += detalle.precio - descuento;
      }
    });
    this.localModel.factura.totalServicios = $filter('currency')(totalServicios, 'Gs.', 0);
    this.localModel.factura.totalProductos = $filter('currency')(totalProductos, 'Gs.', 0);
    this.localModel.factura.totalCuota = totalServicios + totalProductos;

    if (this.model.factura.descuento) {
      this.localModel.factura.totalFactura = this.localModel.factura.totalFactura - this.model.factura.descuento;
    }

    this.localModel.factura.total = $filter('currency')(this.model.total, 'Gs.', 0);
    this.localModel.factura.descuento = $filter('currency')(this.model.descuento, 'Gs.', 0);
  }

  /**
   * Función que se encarga de mostrar mensajes de error/exito en base al estado actual
   * 
   * @param {object} state
   */
  function handleStatus(state) {
    if (state.form.notFound) {
      const msg = `${this.translations['No existe el elemento con ID']} ${$stateParams.uid}`;
      ngNotify.set(msg, 'warn');
      $timeout(() => $state.go('home.cuotas.list'));
      return;
    }

    if (state.form.error) {
      ngNotify.set(formatErrorMessage(state.form.error.message), { type: 'error', html: true });
    }

    if (state.form.created) {
      this.cobrarCuotaNotify(state.form.created);
      $state.go('home.cuotas.list');
    }
  }

  function doSubmit() {
    // Validacion
    if (this.localModel.totalDetalles < this.payloadCuotas.montoAPagar) {
      ngNotify.set(this.translations['Total detalles no cubre el monto a pagar'], 'warn');
      return;
    }
    if (this.model.estado.value === 'Completado') {
      ngNotify.set(this.translations['No se puede cobrar una factura que ya ha sido saldada'], 'warn');
      return;
    }
    if (this.localModel.detalles.length < 1) {
      ngNotify.set(this.translations['Debe seleccionar medios de pago para registrar el cobro'], 'warn');
      return;
    }
    if (this.payloadCuotas.montoAPagar > this.model.saldo && Math.abs(this.payloadCuotas.montoAPagar - this.model.saldo) > this.model.cantidadCuotas) {
      ngNotify.set(this.translations['El monto a pagar supera al saldo pendiente'], 'warn');
      return;
    }
    if (this.payloadCuotas.cantidadCuotasAPagar > this.model.cantidadCuotas - this.model.cantidadCuotasPagadas) {
      ngNotify.set(this.translations['No se puede pagar mas cuotas que las pendientes'], 'warn');
      return;
    }
    if ( Math.floor((this.payloadCuotas.montoAPagar + this.model.excedente)/this.model.montoCuotas) !== this.payloadCuotas.cantidadCuotasAPagar) {
      ngNotify.set(this.translations['La cantidad de cuotas a pagar y el monto no coinciden'], 'warn');
      return;
    }

    // Payload
    let caja = localStorageService.get('caja');
    let pagos = Object.assign([], this.localModel.detalles);
    let vuelto = this.localModel.vuelto;
    // Si hay vuelto, hay que descontar el mismo del monto de los pagos, de manera que la suma de los pagos quede igual 
    // al monto a pagar (y no se procese ingreso de mas en las transacciones, etc..)
    if (vuelto) {
      // Por cada pago
      pagos.forEach(function(detalle) {
        // Si es en efectivo, y sigue habiendo vuelto que descontar
        if (detalle.formaPago.formaDesembolso.value === 'Efectivo' && vuelto > 0) {
          let diff = detalle.monto - vuelto;
          if (diff === 0) {
            // Si la cantidad restante de vuelto cubre justo el monto de este detalle, se anulan
            vuelto = 0;
            detalle.monto = 0;
          } else if (diff < 0) {
            // Si el vuelto restante es mayor al monto de este detalle
            // se descuenta del vuelto restante la cantidad del monto del detalle
            vuelto = -diff;
            // se cancela el monto del detalle
            detalle.monto = 0;
          } else {
            // Si el monto del detalle es mayor
            // se descuenta del monto del detalle, lo que quedaba del vuelto
            detalle.monto = diff;
            // se cancela el vuelto
            vuelto = 0;
          }
        }
      });
      // Filtrar solo los pagos que no quedaron anulados
      pagos = pagos.filter((detalle)=>{return detalle.monto > 0});
    }
    let payload = {
      pagos,
      sesionCajaId: caja.sesionActual.id,
      montoAPagar: this.payloadCuotas.montoAPagar,
      cantidadCuotasAPagar: this.payloadCuotas.cantidadCuotasAPagar,
      excedente: this.payloadCuotas.nuevoExcedente,
      numeroRecibo: this.payloadCuotas.numeroRecibo
    };
    
    // Submit
    let self = this;
    $ngRedux.dispatch(rest.actions.cobrarCuota({ id: this.model.id }, {
      body: JSON.stringify(payload)
    }, (err, data) => {
      if (!err) {
        ngNotify.set(self.translations['Cobrada Correctamente'], 'success');
        $state.go('home.cuotas.list');
      } else if (err) {
        ngNotify.set(formatErrorMessage(err.message), { type: 'error', html: true });
      }
    }));
  }

  function updateTotales() {
    let totalEfectivo = 0;
    let totalOtros = 0;

    this.localModel.detalles.forEach(function(detalle) {
      if (detalle.formaPago.formaDesembolso.value === 'Efectivo') {
        totalEfectivo += detalle.monto;
      } else {
        totalOtros += detalle.monto;
      }
    });

    this.localModel.totalDetalles = totalEfectivo + totalOtros;
    let diff = this.localModel.totalDetalles - this.payloadCuotas.montoAPagar;
    this.localModel.vuelto = diff > 0? diff : 0;
    this.localModel.restante = this.payloadCuotas.montoAPagar - this.localModel.totalDetalles;
  }

  this.filterProcesadora = filterProcesadora.bind(this);

  function filterProcesadora() {
    if (!this.procesadorasTarjetas)
      return;

    let formaPagoSeleccionadaId = this.localModel.nuevoDetalle.formaPago.id;
    this.procesadorasTarjetasFiltradas = this.procesadorasTarjetas.filter(v => v.formaPago && v.formaPago.id === formaPagoSeleccionadaId);
  }

  function onSelectFormaPago() {
    $scope.form.$setUntouched();
    if (this.localModel.nuevoDetalle.formaPago && (this.localModel.nuevoDetalle.formaPago.formaDesembolso.value !== 'Tarjeta de crédito' &&
        this.localModel.nuevoDetalle.formaPago.formaDesembolso.value !== 'Tarjeta de débito')) {
      this.localModel.nuevoDetalle.procesadoraTarjeta = null;
      this.localModel.nuevoDetalle.emisorTarjeta = null;
      this.localModel.nuevoDetalle.marcaTarjeta = null;
    }
    this.filterProcesadora();
  }

  function newDetalle() {
    this.detalleSubmitted = true;
    $scope.form.importe.$setValidity('custom', true);
    $scope.form.importe.$setTouched();
    if (!$scope.form.$valid) {
      return;
    }

    if (this.localModel.nuevoDetalle.formaPago.formaDesembolso.value !== 'Efectivo' &&
      (this.localModel.nuevoDetalle.monto + this.localModel.totalDetalles) > this.localModel.totalCuota) {
      this.mostrarConceptoNoCuotado = true;
    }

    let detalle = Object.assign({}, this.localModel.nuevoDetalle);
    this.localModel.detalles.push(detalle);
    this.localModel.nuevoDetalle = {
      formaPago: this.formaPagoDefault
    };
    this.detalleSubmitted = false;
    this.updateTotales();
    $scope.form.$setUntouched();
  }

  function deleteDetalle(detalle) {
    _.remove(this.localModel.detalles, detalle);
    this.updateTotales();
  }

  function renderDescripcionFormaPago(detalle) {
    let descripcion = detalle.formaPago.descripcion;
    if (detalle.formaPago.formaDesembolso.value === 'Tarjeta de crédito' || detalle.formaPago.formaDesembolso.value === 'Tarjeta de débito') {
      descripcion += ` (${detalle.formaPago.formaDesembolso.name}/${detalle.procesadoraTarjeta.nombre}${detalle.emisorTarjeta ? '/' + detalle.emisorTarjeta.nombre: ''}${detalle.marcaTarjeta ? '/' + detalle.marcaTarjeta.nombre: ''}/${detalle.numeroVoucher})`;
    } else if (detalle.formaPago.formaDesembolso.value === 'Cheque') {
      descripcion += ` (${detalle.formaPago.formaDesembolso.name}${detalle.chequeEntidadBancaria ? '/' + detalle.chequeEntidadBancaria: ''}/${detalle.chequeNumero}${detalle.chequeNumeroCuenta ? '/' + detalle.chequeNumeroCuenta : ''})`;
    } else if (detalle.formaPago.formaDesembolso.value === 'Efectivo') {
      descripcion += ` (${detalle.formaPago.formaDesembolso.name})`;
    }
    return descripcion;
  }

  function renderFormaPago(formaPago) {
    return `${formaPago.descripcion} (${formaPago.formaDesembolso.name})`;
  }

  function renderCliente(cliente) {
    let numeroDoc = cliente.numeroDocumento ? cliente.numeroDocumento : 'Sin Nro. Documento';
    return `${cliente.razonSocial} (${numeroDoc})`;
  }

  function cancel() {
    $state.go('home.cuotas.list');
  }

  
  /**
   * Cuando setea este campo, se calculan valores para pagar exactamente la cantidad especificada
   * de cuotas, teniendo en cuenta el excedente actual a favor del cliente, y por tanto el nuevo
   * excedente sera 0.
   */
  function onCantidadCuotasAPagarChange() {
    this.payloadCuotas.montoAPagar = (this.model.montoCuotas * this.payloadCuotas.cantidadCuotasAPagar) - this.model.excedente;
    //this.payloadCuotas.montoAPagar = this.payloadCuotas.montoAPagar - (this.payloadCuotas.montoAPagar % 50); 
    let nuevoSaldo = this.model.saldo - this.payloadCuotas.montoAPagar;
    nuevoSaldo = nuevoSaldo < 0? 0 : nuevoSaldo;
    this.localModel.nuevoSaldo = $filter('currency')(nuevoSaldo, 'Gs.', 0);
    this.localModel.nuevoExcedente = $filter('currency')(0, 'Gs.', 0);
  }

  /**
   * Cuando se setea este campo, se calcula cuantas cuotas cubre el monto especificado, y el excedente
   * en caso que exista. Tambien se recalcula el saldo restante el la tabla de formas de pago.
   */
  function onMontoAPagarChange() {
    let cantidadCuotasAPagar = Math.floor((this.payloadCuotas.montoAPagar+this.model.excedente)/this.model.montoCuotas);
    this.payloadCuotas.cantidadCuotasAPagar = cantidadCuotasAPagar;
    let nuevoExcedente = (this.payloadCuotas.montoAPagar+this.model.excedente) % this.model.montoCuotas;
    this.payloadCuotas.nuevoExcedente = nuevoExcedente;
    this.localModel.nuevoExcedente = $filter('currency')(nuevoExcedente, 'Gs.', 0);
    let nuevoSaldo = this.model.saldo - this.payloadCuotas.montoAPagar;
    nuevoSaldo = nuevoSaldo < 0? 0 : nuevoSaldo;
    this.localModel.nuevoSaldo = $filter('currency')(nuevoSaldo, 'Gs.', 0);
    this.updateTotales();
  }

  function verFactura() {
    // TODO solucionar tema de scopes para poder abrir en otro tab sin que se interfieran
    //var url = $state.href('home.facturas.uid.view', {uid: this.model.factura.id});
    //window.open(url,'_blank');
    $state.go('home.facturas.uid.view', {uid: this.model.factura.id});
  }

}


// WEBPACK FOOTER //
// ./src/components/cuotas/cobrar/form.component.js